import { render, staticRenderFns } from "./ValidateTsFooter.vue?vue&type=template&id=7272baa7&scoped=true&"
import script from "./ValidateTsFooter.vue?vue&type=script&lang=js&"
export * from "./ValidateTsFooter.vue?vue&type=script&lang=js&"
import style0 from "./ValidateTsFooter.vue?vue&type=style&index=0&id=7272baa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7272baa7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7272baa7')) {
      api.createRecord('7272baa7', component.options)
    } else {
      api.reload('7272baa7', component.options)
    }
    module.hot.accept("./ValidateTsFooter.vue?vue&type=template&id=7272baa7&scoped=true&", function () {
      api.rerender('7272baa7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MobileViews/ValidateTs/ValidateTsFooter.vue"
export default component.exports